import { NavLink, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Crown } from 'lucide-react'

import { SUBSCRIPTION_NAV_ITEM, isNavItemActive } from '@/constants/user-menu'
import { Button } from '@/shared/components/ui/button'
import { cn } from '@/shared/lib/utils'

type SubscriptionNavLinkProps = {
  className?: string
  variant?: 'header' | 'drawer'
  onNavigate?: () => void
}

export function SubscriptionNavLink({
  className,
  variant = 'header',
  onNavigate,
}: SubscriptionNavLinkProps) {
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const active = isNavItemActive(pathname, SUBSCRIPTION_NAV_ITEM)

  return (
    <Button
      asChild
      variant="member"
      data-active={active ? true : undefined}
      className={cn(
        variant === 'drawer' && 'inline-flex xl:hidden w-full justify-center',
        variant === 'header' && 'portal-header-pill',
        active && 'is-active',
        className,
      )}
    >
      <NavLink to={SUBSCRIPTION_NAV_ITEM.to} onClick={onNavigate}>
        <Crown size={16} aria-hidden />
        <span className="portal-header-pill__text">{t(SUBSCRIPTION_NAV_ITEM.i18nKey)}</span>
      </NavLink>
    </Button>
  )
}
